// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Q0Ej5\\+Va{position:relative}._0IvZJ00Y{font-size:.81rem;font-weight:500;line-height:1.39}.sfmVvCVR{padding-top:calc(var(--spacing-default)*5)}.VZEFRVk2{width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"form": "Q0Ej5+Va",
	"hint": "_0IvZJ00Y",
	"footer": "sfmVvCVR",
	"btn": "VZEFRVk2"
};
module.exports = ___CSS_LOADER_EXPORT___;
